// Public surface of the teams suite.

export {
  TeamsProvider,
  useTeamsContext,
  TEAM_DATA_EXTENT,
  TEAM_LIST_CATEGORY,
  type TeamDataExtent,
  type TeamListCategory,
} from './TeamsProvider';

// Queries
export { useTeams } from './use-teams';
export { useTeam } from './use-team';
export { useTeamMembers } from './use-team-members';

// Mutations
export { useCreateTeam } from './use-create-team';
export { useCreateTeamFromSession } from './use-create-team-from-session';
export { useUpdateTeamFull, type UpdateTeamFullVars } from './use-update-team-full';
export { useDeleteTeam } from './use-delete-team';
export { useReplicateTeam, type ReplicateTeamVars } from './use-replicate-team';
export { useAddTeamMember, type AddTeamMemberVars } from './use-add-team-member';
export { useUpdateTeamMember, type UpdateTeamMemberVars } from './use-update-team-member';
export { useRemoveTeamMember } from './use-remove-team-member';
export { useSetTeamModelMode, type SetTeamModelModeVars } from './use-set-team-model-mode';

// Helpers (pure functions, not hooks)
export {
  getTeamIdsForListCategory,
} from './team-list-helpers';
